<template>
    <div v-if="view.id && table.id" :key="table.id + '-' + view.id" class="full-height-container">
        <tab-navigator v-if="!hideTabNavigation" :table="table"></tab-navigator>
        <view-toolbar v-if="!hideTabNavigation" :table="table" :view="view"></view-toolbar>
        <view-renderer :table="table" :view="view"></view-renderer>
    </div>
</template>

<script>
    import ViewService from "../services/ViewService";
    import TabNavigator from "./nav/TabNavigator.vue";
    import ViewToolbar from "./toolbar/ViewToolbar.vue";
    import ViewRenderer from "./renderers/ViewRenderer.vue";
    import UserUtil from "../utils/UserUtil";

    export default {
        name: 'ViewManager',
        components: {ViewRenderer, ViewToolbar, TabNavigator},
        computed: {
            hideTabNavigation() {
                return this.model.app.hide_tab_navigation
            }
        },
        data () {
            return {
                model: webase.model,
                service: new ViewService(),
                view: {
                    id: null,
                    name: '',
                    view_type: ''
                },
                table: {
                    id: null,
                    name: ''
                }
            }
        },
        mounted () {
            window.scrollTo(0, 0)
            let viewId = this.$route.params.id

            // TODO: need to load the View, App and any User/Collaborator data for Public App
            // that is more secure about the data it returns

            this.service.get(viewId).then((response) => {
                webase.utils.app.initViewLayout(response)

                if(response.user) {
                    let user = response.user
                    webase.model.user_id = user.id
                    webase.model.currentUser = user
                    webase.utils.user = new UserUtil(user)
                }

                this.view = response
                let app = response.app
                console.log('View Manager init app')
                webase.utils.app.initAppProperties(app)
                this.model.app = app
                this.table = webase.utils.array.get(this.model.app.tables, this.view.model_id)

                if(this.view.view_type === 'details') {
                    this.routeToDetailsRenderer()
                }

            }).catch((message) => {
                console.log('error loading view')
                console.log(message)
            })
        },
        updated() {
            let viewId = this.$route.params.id
        },
        methods: {
            routeToDetailsRenderer() {
                let viewService = new ViewService()

                viewService.getData(this.view, this.table).then((response) => {
                    let documents = response

                    if(documents.length > 0) {
                        let document = documents[0]
                        this.$router.push({name: 'details-view', params: {view_id: this.view.id, record_id: document['id']}})
                    }

                }).catch((message) => {
                    console.log('error loading data from table')
                    console.log(message)
                })
            },
        }
    }
</script>

<style>

</style>
